import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const LOFI_STATIONS = [
  {
    id: 'lofigirl',
    name: 'Lofi Girl 24/7',
    genre: 'Lofi Hip Hop',
    url: 'https://play.streamafrica.net/lofigirl',
  },
  {
    id: 'nightwave',
    name: 'Nightwave Plaza',
    genre: 'Vaporwave / Chill',
    url: 'https://radio.plaza.one/mp3',
  },
  {
    id: 'somadefcon',
    name: 'SomaFM Def Con',
    genre: 'Cyberpunk Beats',
    url: 'https://ice6.somafm.com/defcon-128-mp3',
  },
  {
    id: 'chillhop',
    name: 'ChillHop Radio',
    genre: 'Chill Beats',
    url: 'https://stream.zeno.fm/f3wvbbqmdg8uv',
  },
];

let globalAudio = null;

export const useLofiStore = create(
  persist(
    (set, get) => ({
      isPlaying: false,
      stationIndex: 0,
      volume: 0.6,
      muted: false,

      initAudio: () => {
        if (typeof window === 'undefined') return;
        if (!globalAudio) {
          globalAudio = new Audio();
          globalAudio.crossOrigin = 'anonymous';
          globalAudio.volume = get().volume;
          globalAudio.src = LOFI_STATIONS[get().stationIndex]?.url || LOFI_STATIONS[0].url;

          globalAudio.addEventListener('error', () => {
            console.warn('Lofi stream error, advancing to next station');
            get().nextStation();
          });
        }
      },

      togglePlay: () => {
        const { isPlaying, initAudio, stationIndex, volume } = get();
        initAudio();

        if (!globalAudio) return;

        if (isPlaying) {
          globalAudio.pause();
          set({ isPlaying: false });
        } else {
          if (!globalAudio.src || globalAudio.src !== LOFI_STATIONS[stationIndex]?.url) {
            globalAudio.src = LOFI_STATIONS[stationIndex]?.url;
          }
          globalAudio.volume = volume;
          globalAudio.play()
            .then(() => set({ isPlaying: true }))
            .catch(() => set({ isPlaying: false }));
        }
      },

      nextStation: () => {
        const nextIdx = (get().stationIndex + 1) % LOFI_STATIONS.length;
        set({ stationIndex: nextIdx });

        if (globalAudio) {
          globalAudio.src = LOFI_STATIONS[nextIdx].url;
          if (get().isPlaying) {
            globalAudio.play().catch(() => set({ isPlaying: false }));
          }
        }
      },

      prevStation: () => {
        const prevIdx = (get().stationIndex - 1 + LOFI_STATIONS.length) % LOFI_STATIONS.length;
        set({ stationIndex: prevIdx });

        if (globalAudio) {
          globalAudio.src = LOFI_STATIONS[prevIdx].url;
          if (get().isPlaying) {
            globalAudio.play().catch(() => set({ isPlaying: false }));
          }
        }
      },

      setVolume: (vol) => {
        const v = Math.max(0, Math.min(1, vol));
        set({ volume: v });
        if (globalAudio) {
          globalAudio.volume = v;
        }
      },
    }),
    {
      name: 'pedro_lofi_player_v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ stationIndex: s.stationIndex, volume: s.volume }),
    }
  )
);
